module.exports = __webpack_public_path__ + "static/weeks123_3-0a10e3037bbd98baf30801d2b7a664ab.jpg";